import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RingMegService {
  url = 'https://hook.eu1.make.com/sjcubv5ioagejmta29k2hkyi1bonqyyi';

  constructor(private _httpClient: HttpClient) {}

  ringMeg(payload: string) {
    return this._httpClient.post(this.url, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
}
